'use client'

import { ProductTile } from 'src/components/design-system'
import { getTileBorderClasses, getTileGridClass } from 'src/components/list/getTileBorderClasses'

export default function ProductTileGrid({
  tiles = [],
  desktopColumns = 4,
  withSidebar = false,
  className = '',
  gridClassName,
  tileWrapperClassName = 'mt-25 pb-25',
  tileClassName = '',
}) {
  const resolvedGridClassName =
    gridClassName ?? ['mb-32 grid', getTileGridClass(desktopColumns, { withSidebar })].join(' ')

  return (
    <div className={['list-elements', resolvedGridClassName, className].filter(Boolean).join(' ')}>
      {tiles.map((tile, index) => {
        const bordersClassName = getTileBorderClasses(index, { desktopColumns, withSidebar })
        const key = tile?.id ?? index

        return (
          <div key={key} className={[bordersClassName, tileWrapperClassName].filter(Boolean).join(' ')}>
            <ProductTile
              className={tile?.className || tileClassName}
              imageSrc={tile?.imageSrc}
              imageAlt={tile?.imageAlt}
              tags={tile?.tags}
              title={tile?.title}
              subtitle={tile?.subtitle}
              footerLines={tile?.footerLines}
              metadata={tile?.metadata}
              ctaHref={tile?.ctaHref}
              isArticle={tile?.isArticle}
            />
          </div>
        )
      })}
    </div>
  )
}
